import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      display: 'flex',
      flexDirection: 'column',
      gap: [6, 8], // Clean spacing between sections
    };

    this.header = {
      mb: [4, 6],
    };

    this.toggles = {
      mb: [5, 7],
      display: 'flex',
      justifyContent: ['center', 'center', 'flex-start'],
    };

    this.carousel = {
      position: 'relative',
    };
  })()
);
